import React from 'react'
import DropdownSelect from '../../../../../../common/inputs/dropdownSelect/DropdownSelect'
import { LocationClassificationTypeOption } from '../../../../../../../@types/dropdown-types'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'

const LocationClassificationType: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  insertionData,
  onChange,
  screenName,
  wrapperClassName = 'grid-item one-half padding-right-m',
}) => {
  return (
    <div className={wrapperClassName}>
      <DropdownSelect
        id='location-classification-type'
        name='locationClassificationType'
        label='wizard.screen.otherFacilities.locationClassificationType'
        value={insertionData.locationClassificationType}
        noInformation={LocationClassificationTypeOption.NO_INFORMATION}
        options={{
          translationKeyGroup: 'wizard.screen.otherFacilities.locationClassificationTypeOptions',
          options: Object.keys(LocationClassificationTypeOption),
        }}
        onChange={(value) => onChange({ screen: screenName, property: 'locationClassificationType' }, value.value!)}
        allowEmpty
      />
    </div>
  )
}

export default LocationClassificationType
